import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    // viewBox extended by 1 unit on top + bottom to avoid 1-px sub-pixel
    // clipping of the rectangle outline at certain scales (e.g. 28px).
    viewBox: '0 -1 20 28',
    defaultAriaLabel: 'PDF Builder Icon',
};

export const PdfBuilderIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props} fill="currentColor">
            <path d="M5 9C4.44772 9 4 9.44771 4 10C4 10.5523 4.44772 11 5 11H15C15.5523 11 16 10.5523 16 10C16 9.44771 15.5523 9 15 9H5Z" />
            <path d="M4 14C4 13.4477 4.44772 13 5 13H15C15.5523 13 16 13.4477 16 14C16 14.5523 15.5523 15 15 15H5C4.44772 15 4 14.5523 4 14Z" />
            <path d="M5 17C4.44772 17 4 17.4477 4 18C4 18.5523 4.44772 19 5 19H13C13.5523 19 14 18.5523 14 18C14 17.4477 13.5523 17 13 17H5Z" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M0 1C0 0.447715 0.447717 0 1 0H16C16.5523 0 17 0.447715 17 1V4H18C19.1046 4 20 4.89543 20 6V24C20 25.1046 19.1046 26 18 26H2C0.895431 26 0 25.1046 0 24V1ZM15 2V4H2V2H15ZM2 6V24H18V6H2Z"
            />
        </SvgIcon>
    );
};
